module.exports = __webpack_public_path__ + "static/media/sweetshop-scales-illustration.dfae1a7e.jpg";